"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationDecorator = void 0;
const OperationDuration_1 = require("./OperationDuration");
const OperationErrorHandler_1 = require("./OperationErrorHandler");
const OperationFinallyHooks_1 = require("./OperationFinallyHooks");
const OperationTree_1 = require("./OperationTree");
const wrapTryCatchFinallyPromisable_1 = require("./wrapTryCatchFinallyPromisable");
class OperationDecorator {
    static createDecoratorFactory(...hookProviders) {
        const decorator = (decoratorArgs) => {
            return function (classProto, methodName, descriptor) {
                const originalMethod = descriptor.value;
                if (!(originalMethod instanceof Function))
                    throw new Error('Track decorator can only be applied to class methods');
                const decoratorOf = {
                    classProto,
                    methodName,
                    descriptor,
                    originalMethod
                };
                descriptor.value = (0, wrapTryCatchFinallyPromisable_1.wrapTryCatchFinallyPromisable)(originalMethod, (ctx) => {
                    ctx.decoratorOf = decoratorOf;
                    ctx.decoratorArgs = decoratorArgs;
                    return hookProviders.map((h) => h.getTryCatchFinallyHook(ctx));
                });
            };
        };
        const decoratorUtils = {};
        for (const hookProvider of hookProviders) {
            Object.assign(decoratorUtils, hookProvider.getDecoratorUtils?.() || {});
        }
        return Object.assign(decorator, decoratorUtils);
    }
    static createDecoratorFactoryWithDefault(...customHookProviders) {
        return OperationDecorator.createDecoratorFactory(OperationErrorHandler_1.OperationErrorHandler, OperationTree_1.OperationTree, OperationDuration_1.OperationDuration, OperationFinallyHooks_1.OperationFinallyHooks, ...customHookProviders);
    }
    static getOperationName(ctx) {
        const ctxDecorated = ctx;
        return (ctxDecorated.decoratorArgs?.operation ||
            ctxDecorated.decoratorOf?.methodName ||
            ctxDecorated.decoratorOf?.originalMethod?.name);
    }
}
exports.OperationDecorator = OperationDecorator;
//# sourceMappingURL=OperationDecorator.js.map